import dynamic from "next/dynamic";
import FixedLoader from 'components/FixedLoader';

const ShareModal = dynamic(() => import("./Modal"), {
  ssr: false,
  loading: () => <FixedLoader />,
});

export default ShareModal;